<div *ngIf="isSet && isActif" class="chart-wrapper border position-absolute" cdkDrag [cdkDragDisabled]="setting!=true" cdkDragBoundary=".example-boundary"  [style.height.px]="height" [style.width.px]="width" [style.top.px]="top" [style.left.px]="left" (cdkDragEnded)="dragEnd($event)">
    <span>
        <button type="button" class="btn btn-secondary btn-sm" (click)="showSetting()">
          <i class="fa fa-cog" aria-hidden="true"></i>
        </button>
        <mat-slider (input)="onInputChange($event.value)" min="200" max="600" step="5" [value]='height' thumbLabel *ngIf="setting==true"></mat-slider>
        <button type="button" class="btn btn-sm btn-success" cdkDragHandle *ngIf="setting==true">
          <i class="fa fa-arrows" aria-hidden="true"></i>
        </button> 
        <span>
          <button type="button" class="btn btn-sm " (click)="changeStyle('pie')" *ngIf="setting==true" [ngClass]="barChartType == 'pie' ? 'btn-outline-success' : 'btn-outline-danger'">
            <i class="fa fa-pie-chart" aria-hidden="true"></i>
          </button> 
          <button type="button" class="btn btn-sm  btn-outline-success"  (click)="changeStyle('line')" *ngIf="setting==true" [ngClass]="barChartType == 'line' ? 'btn-outline-success' : 'btn-outline-danger'">
            <i class="fa fa-line-chart" aria-hidden="true"></i>
          </button> 
          <button type="button" class="btn btn-sm  btn-outline-success" (click)="changeStyle('bar')" *ngIf="setting==true" [ngClass]="barChartType == 'bar' ? 'btn-outline-success' : 'btn-outline-danger'">
            <i class="fa fa-bar-chart" aria-hidden="true"></i>
          </button> 
        </span>
        <button type="button" class="btn btn-sm btn-danger" (click)="setInactive('<bar-graph></bar-graph>')" *ngIf="setting==true">
          <i class="fa fa-ban" aria-hidden="true"></i>
        </button> 
    </span>
    <canvas baseChart 
    [datasets]="barChartData"
    [labels]="barChartLabels"
    [options]="barChartOptions"
    [plugins]="barChartPlugins"
    [legend]="barChartLegend"
    [chartType]="barChartType">
  </canvas>
</div>